import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user-icon",
  "use": "icon-user-icon-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 40 40\" id=\"icon-user-icon\">\n<style type=\"text/css\">\n\t#icon-user-icon .st0{fill:#515AAF;}\n\t#icon-user-icon .st1{fill:#EBECFF;}\n</style>\n<g transform=\"translate(-1671 -15)\">\n\t<path class=\"st0\" d=\"M1691,15L1691,15c11,0,20,9,20,20l0,0c0,11-9,20-20,20l0,0c-11,0-20-9-20-20l0,0C1671,24,1680,15,1691,15z\" />\n\t<path class=\"st1\" d=\"M1682,41c0-2.8,4-5,9-5s9,2.2,9,5c0,2.8-4,5-9,5S1682,43.8,1682,41z M1685,29c0-3.3,2.7-6,6-6s6,2.7,6,6\n\t\ts-2.7,6-6,6S1685,32.3,1685,29z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user-icon.svg
// module id = KYAJ
// module chunks = 97